<template>
  <div>
    <el-table ref="tableSort" border v-if="countdata" :data="countdata">
      <el-table-column
        align="center"
        label="计入统计设备"
        prop="总台数"
        :formatter="formatDecimal"
        show-overflow-tooltip
        width="180"
      />
      <el-table-column
        align="center"
        label="总计金额"
        prop="总计"
        :formatter="formatDecimal"
        show-overflow-tooltip
        width="180"
      />
      <el-table-column
        align="center"
        label="银联"
        prop="银联"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="工行"
        prop="工行"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="微信"
        prop="微信"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="支付宝"
        prop="支付宝"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="现金"
        prop="现金"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="POS机"
        prop="POS机"
        v-if="filterPos"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
    </el-table>
    <el-table
      v-if="data"
      ref="tableSort"
      border
      :data="data"
      height="330"
      stripe
    >
      <el-table-column
        align="center"
        label="设备名称"
        prop="name"
        show-overflow-tooltip
        width="180"
      />

      <el-table-column
        align="center"
        label="总计金额"
        prop="total"
        :formatter="formatDecimal"
        show-overflow-tooltip
        width="180"
      />
      <el-table-column
        align="center"
        label="银联"
        prop="银联"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="工行"
        prop="工行"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="微信"
        prop="微信"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="支付宝"
        prop="支付宝"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="现金"
        prop="现金"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="POS机"
        prop="POS机"
        v-if="filterPos"
        :formatter="formatDecimal"
        show-overflow-tooltip
      />
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    countdata: {
      type: Array,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => {},
    },
    filterPos: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    console.log(333555, this.filterPos)
  },
  methods: {
    formatDecimal(row, column) {
      const value = row[column.property] * 1;
      // 如果值为数值类型，保留两位小数，否则返回原值
      return value.toFixed(2);
    },
  },
};
</script>

<style scoped></style>